import * as yup from "yup";
import YupPassword from "yup-password";
import i18n from "../../../../../../i18n";

YupPassword(yup); // extend yup

const requiredMessage = () => i18n.t("validation.required", {ns: "common"});

export const createCallRecordValidation = yup.object().shape({
    courierId: yup.string().required(requiredMessage),
    callStatus: yup.string().required(requiredMessage)
});
